var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._g(_vm._b({staticClass:"position-relative"},'b-button',_vm.$attrs,false),_vm.$listeners),[_c('span',{class:{'invisible': _vm.busy}},[_vm._t("default")],2),(_vm.busy)?_c('div',{staticClass:"centered"},[_c('b-spinner',{staticClass:"align-middle",attrs:{"small":""}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }